module.exports = __webpack_public_path__ + "img/shopify-logo.e7c00c44.svg";